<template>
  <div class="carousel-container">
    <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
      <img src="../../public/assets/images/norterra/Norterra_Banner1.png" class="d-block w-100" alt="...">
    </div>
    <div class="carousel-overlay-text">
      <div class="col-10 mx-auto col-lg-8 col-xl-8 ">
        <img src="../../public/assets/images/logos/LogoNorterraBlanco.svg" class="col-6 col-lg-7 col-xl-7" alt="...">
        <img src="../../public/assets/images/home/linea.svg" class="img-line d-block mx-auto" alt="...">
        <p class="font32">Próximamente</p>
        <div class=" w-fc mx-auto px-3">
          <p class="text-uppercase font16 mt-3">Mantente en contacto para descubrir más</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponenteCarrousel'
}
</script>
